import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @mui/material components
import { styled } from "@mui/material/styles";
// @mui/icons-material

// core components
import styles from "../assets/jss/material-dashboard-react/components/cardStyle";

// Convert styles to a styled component
const BaseCard = styled("div")(({ theme }) => ({
  ...styles.card,
}));

const PlainCard = styled(BaseCard)(({ theme }) => ({
  ...styles.cardPlain,
}));

const ProfileCard = styled(BaseCard)(({ theme }) => ({
  ...styles.cardProfile,
}));

const ChartCard = styled(BaseCard)(({ theme }) => ({
  ...styles.cardChart,
}));

export default function Card(props) {
  const { className, children, plain, profile, chart, ...rest } = props;
  let Component = BaseCard;
  if (plain) Component = PlainCard;
  else if (profile) Component = ProfileCard;
  else if (chart) Component = ChartCard;

  return (
     <Component className={classNames(className)} {...rest}>
      {children}
    </Component>
  );
}

Card.propTypes = {
  className: PropTypes.string,
  plain: PropTypes.bool,
  profile: PropTypes.bool,
  chart: PropTypes.bool,
  children: PropTypes.node
};
